export enum SliderArrow {
  INSIDE,
  OUTSIDE,
}

export type SliderWithOutsideArrows = {
  type: SliderArrow.OUTSIDE;
  componentLeft?: React.ReactNode;
  componentRight?: React.ReactNode;
  dark?: boolean;
  visibleForMobile?: boolean;
};

export type SliderWithInsideArrows = {
  type: SliderArrow.INSIDE;
  insetLeftArrow?: string;
  insetRightArrow?: string;
  visibleForMobile?: boolean;
};

export interface ScArrowProps {
  hide?: boolean;
  isActive?: boolean;
  visibleForMob?: boolean;
  inset?: string;
}

export type SliderWithArrowProps =
  | SliderWithInsideArrows
  | SliderWithOutsideArrows;

interface GridParams {
  cols?: number;
  rows?: number;
}

interface Breakpoints<T> {
  desktopL?: T;
  desktop?: T;
  tablet?: T;
  mobile?: T;
  mobileS?: T;
}

export interface SlideGrid extends Breakpoints<GridParams> {}
